import request from '@/utils/request'

export function index(params) {
  return request({
      url: '/settings/telegramManagers',
      method: 'get',
      params: params
  })
}

export function show(id) {
  return request({
      url: `/settings/telegramManagers/${id}`,
      method: 'get'
  })
}

export function store(data) {
  return request({
      url: '/settings/telegramManagers',
      method: 'post',
      data
  })
}

export function update(data) {
  return request({
      url: `/settings/telegramManagers/${data.id}`,
      method: 'put',
      data
  })
}


export function inventory(params) {
  return request({
      url: '/settings/telegramManager/inventory',
      method: 'get',
      params
  })
}
export function staff_list(params) {
  return request({
      url: '/settings/telegramManager/staff_list',
      method: 'get',
      params
  })
}


export function destroy(id) {
  return request({
      url: `/settings/telegramManagers/${id}`,
      method: 'delete',
  })
}
